import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: true
})
export class SafeHtmlPipe implements PipeTransform {

  constructor(private sanitize: DomSanitizer) { }

  transform(html: string): any {
    return this.sanitize.bypassSecurityTrustHtml(html);
  }

}
